<template>
  <div class="border-t border-gray-300 w-full my-2"></div>
</template>